import queryString from "query-string";

export default function getQueryStringVariable(key: string): string | string[] {
  const variables = queryString.parse(location.search, {
    arrayFormat: "bracket",
  });
  return variables[key];
}
